import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useUIStore } from '../../store/uiStore';

export function Layout() {
  const { sidebarOpen, theme, setSidebarOpen } = useUIStore();

  useEffect(() => {
    if (theme === 'dark') {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [theme]);

  return (
    <div className={`flex h-screen bg-gray-100 ${theme === 'dark' ? 'dark-mode' : ''}`}>
      
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 md:hidden transition-opacity"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <Sidebar />
      
      <div 
        className={`flex-1 flex flex-col w-full transition-all duration-300 
        ${sidebarOpen ? 'md:ml-64' : 'md:ml-20'}`}
      >
        <Header />
        <main className="flex-1 overflow-auto p-4 sm:p-6 w-full max-w-full">
          <Outlet />
        </main>
      </div>
    </div>
  );
}